/**
 * EVO — til almashtirgichi (segmentli boshqaruv).
 *
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ NIMA UCHUN RO'YXAT EMAS, UCHTA SEGMENT                                   ║
 * ║                                                                          ║
 * ║ Egasi: «til katta joy egallayapti, u ham kichkina bo'lsin — uz/ru/en     ║
 * ║ yetadi».                                                                 ║
 * ║                                                                          ║
 * ║ Ilgari bu `<select>` edi va uning ichida to'liq nomlar turardi           ║
 * ║ («O'zbekcha», «Русский»). Tanlov qutisining kengligi eng uzun nomga      ║
 * ║ qarab o'lchanadi, ya'ni panelda ~130 px doimiy band bo'lardi — kuniga    ║
 * ║ bir marta ham bosilmaydigan element uchun. Ustiga, joriy tilni ko'rish   ║
 * ║ uchun o'qish kerak edi; qolgan ikkitasi esa umuman ko'rinmasdi.          ║
 * ║                                                                          ║
 * ║ Uchta segment ~100 px oladi, joriy tilni RANG bilan ko'rsatadi (o'qish   ║
 * ║ shart emas) va boshqa tilga o'tish BIR bosish — ro'yxatdagidek ikki      ║
 * ║ emas. Uchta variantdan ko'p bo'lganda bu yechim ishlamas edi, lekin      ║
 * ║ ularning soni uchta va ko'paymaydi (`LOCALES`).                          ║
 * ║                                                                          ║
 * ║ Yig'iladigan ochiluvchi menyu ham RAD ETILDI: u joyni yana kamaytirardi, ║
 * ║ lekin bosishni ikkiga oshirardi va til almashtirish odatda ilovani       ║
 * ║ birinchi marta ochgan odamga kerak — aynan u yashiringan tugmani         ║
 * ║ topolmaydi.                                                              ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ EKRAN O'QUVCHI UCHUN: `role="group"` + `aria-pressed`                    │
 * │                                                                          │
 * │ `<select>` da nom (`aria-label`) va joriy qiymat brauzerdan tayyor       │
 * │ kelardi. Uchta oddiy tugmada esa ular YO'Q: ekran o'quvchi «UZ tugma,    │
 * │ RU tugma, EN tugma» deb o'qib, qaysi biri yoqilganini aytmasdi.          │
 * │                                                                          │
 * │ Shuning uchun guruh nomlanadi (`nav.language`) va har tugma o'z          │
 * │ holatini `aria-pressed` bilan aytadi. `aria-current` yoki `radiogroup`   │
 * │ ham ko'rib chiqildi: `radiogroup` o'q tugmalari bilan boshqarishni       │
 * │ TALAB qiladi (`roving tabindex`), ya'ni Tab bilan segmentga kirib o'q    │
 * │ bosish kerak bo'lardi — uchta tugma uchun ortiqcha murakkablik. Bu       │
 * │ yerda uchalasi ham Tab bilan yetib boriladi va Enter/Probel bilan        │
 * │ bosiladi, ya'ni oddiy tugma xatti-harakati.                              │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ IKKI TUS (`tone`) — CHUNKI VIDJET ENDI IKKI XIL YUZADA TURADI            ║
 * ║                                                                          ║
 * ║ Yuqoridagi izohning O'ZI ogohlantirgan edi: «til almashtirish odatda     ║
 * ║ ilovani BIRINCHI MARTA ochgan odamga kerak». Ammo birinchi marta         ║
 * ║ ochgan odam yuqori panelni umuman KO'RMAYDI — u kirish ekranida turadi   ║
 * ║ va yuqori panel faqat tizimga kirgandan keyin chiziladi. Ya'ni vidjet    ║
 * ║ aynan o'zi mo'ljallangan odamga yetib bormasdi.                          ║
 * ║                                                                          ║
 * ║ Kirish ekrani esa YORUG' sirt (`bg-canvas` + oq karta), korpus emas.     ║
 * ║ Vidjetni o'sha yerga o'zgarishsiz qo'yish IKKI xato berardi:             ║
 * ║                                                                          ║
 * ║   • `bg-chrome-2` (#22272C) — deyarli qora quti oq sahifa o'rtasida;     ║
 * ║     u kirish kartasiga tegishli emas, «yopishtirilgan» bo'lib ko'rinadi; ║
 * ║   • `bg-chrome-accent` (#24AB6B) — logoning aynan rangi va uning         ║
 * ║     yorug' fondagi kontrasti 2.95 (`styles.css`). Ya'ni grafit ustida    ║
 * ║     to'g'ri ishlaydigan urg'u oq sahifada CHEGARADAN TUSHIB qolardi.     ║
 * ║                                                                          ║
 * ║ Shuning uchun tus PROP bo'ldi, sinflar esa jadvalda. Muqobillar:         ║
 * ║                                                                          ║
 * ║   1. `className` propini tashqaridan qabul qilish — RAD ETILDI: u        ║
 * ║      chaqiruvchiga rang tanlashni topshiradi va ertaga uchinchi joyda    ║
 * ║      to'rtinchi rang paydo bo'ladi. Bu yerda tanlov IKKITA va yopiq.     ║
 * ║   2. Alohida `LangSwitchLight` komponenti — RAD ETILDI: butun `LOCALES`  ║
 * ║      aylanasi, `aria-pressed` va `title` mantiqi ikki nusxada qolardi    ║
 * ║      va ulardan biri ertaga tuzatilmay qolishi aniq edi.                 ║
 * ║                                                                          ║
 * ║ Sukut bo'yicha `chrome`: mavjud yagona chaqiruvchi (`topbar.tsx`)        ║
 * ║ o'zgarishsiz qoladi va u yerda hech narsa yozilmasa ham eski xulq        ║
 * ║ saqlanadi.                                                              ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 */
import type { ReactNode } from 'react';
import { LOCALES, type Locale } from '../../lib/i18n';
import { useI18n } from '../../lib/i18n-context';

/**
 * Segmentdagi yozuv — ikki harf.
 *
 * `code.toUpperCase()` ham shu natijani berardi, lekin u kodni EKRAN
 * matniga aylantiradi: ertaga `zh` qo'shilsa, foydalanuvchi «ZH» ni ko'rardi.
 * Aniq jadval esa yangi til qo'shilganda kompilyatsiyada yiqiladi va
 * yozuvni ataylab tanlashga majbur qiladi.
 */
const SHORT_LABELS: Record<Locale, string> = {
  uz: 'UZ',
  ru: 'RU',
  en: 'EN',
};

/**
 * To'liq nom — faqat `title` uchun.
 *
 * Ikki harf tanish odam uchun yetarli, lekin «UZ» ni birinchi marta ko'rgan
 * odam uchun emas. Sichqoncha ustida turganda to'liq nom chiqadi va bu
 * panelda bir piksel ham joy egallamaydi.
 */
const FULL_LABELS: Record<Locale, string> = {
  uz: "O'zbekcha",
  ru: 'Русский',
  en: 'English',
};

/**
 * Vidjet turadigan yuza.
 *
 *   `chrome`  — korpus (yon menyu, yuqori panel). Mavzuga BOG'LIQ EMAS:
 *               ikkala mavzuda ham bir xil grafit.
 *   `surface` — yorug' sirt (kirish ekrani, modal, karta ichi). Mavzu bilan
 *               BIRGA almashadi, chunki `surface-*`/`ink-*` tokenlarining
 *               qorong'i mavzuda o'z qiymatlari bor.
 */
export type LangSwitchTone = 'chrome' | 'surface';

/**
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ RANGLAR JADVALDA — SHART OPERATORLARIDA EMAS                             │
 * │                                                                          │
 * │ Uchta joyda (guruh, faol segment, nofaol segment) uchta `tone === ...`   │
 * │ tekshiruvi yozish ham mumkin edi. Jadval afzal: yangi tus qo'shilganda   │
 * │ TypeScript uchala qatorni ham talab qiladi, ya'ni «guruh foni berilib,   │
 * │ faol segment unutilgan» holat kompilyatsiyada yiqiladi — ekranda emas.   │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ O'LCHANGAN KONTRASTLAR (WCAG chegarasi — 4.5)                            ║
 * ║                                                                          ║
 * ║ Eng muhimi TANLANGAN til: u to'ldirilgan fonda turadi va aynan u         ║
 * ║ o'qilmay qolsa vidjetning butun ma'nosi yo'qoladi.                       ║
 * ║                                                                          ║
 * ║                          matn / fon                     kontrast         ║
 * ║   chrome, faol      #15181B / #24AB6B (chrome-accent)      6.03 ✓        ║
 * ║   chrome, nofaol    #9BA4AE / #22272C (chrome-2)           5.29 ✓        ║
 * ║   surface, faol     #FFFFFF / #14724C (brand, yorug')      5.93 ✓        ║
 * ║   surface, faol     #06180F / #34D98F (brand, qorong'i)   10.01 ✓        ║
 * ║   surface, nofaol   #58607A / #EEF1F8 (surface-2, yorug')  5.51 ✓        ║
 * ║   surface, nofaol   #8E98B4 / #171D2E (surface-2, qorong') 5.83 ✓        ║
 * ║                                                                          ║
 * ║ `surface` da faol fon `brand-vivid` (#24AB6B) EMAS, `brand` (#14724C):   ║
 * ║ logoning o'z yashilida oq matn 2.95 beradi — ya'ni yorug' fonda tanlangan║
 * ║ til deyarli o'qilmasdi. `brand-vivid` faqat SHAKL uchun (`styles.css`).  ║
 * ║                                                                          ║
 * ║ Faol segmentning O'ZI ham fondan ajralishi kerak (WCAG 1.4.11 — 3.0):    ║
 * ║ to'ldirish guruh foniga nisbatan yorug' mavzuda 5.24, qorong'ida 9.16.   ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 *
 * `hover` YO'NALISHI ikki tusda TESKARI va bu ataylab:
 *   • `chrome` da guruh foni `chrome-2` va undan ochiqroq pog'ona korpus
 *     tokenlarida umuman YO'Q — shuning uchun hover QUYUQLASHADI;
 *   • `surface` da esa ochiqroq pog'ona bor (`surface` — yorug' mavzuda oq),
 *     shuning uchun hover YORISHADI. Qorong'i mavzuda o'sha `surface`
 *     `surface-2` dan quyuqroq, ya'ni u yerda yana quyuqlashadi.
 * Har uchala holatda ham holat o'zgarishi KO'RINADI — kerak bo'lgani shu.
 */
const TONE_CLASSES: Record<LangSwitchTone, { group: string; active: string; idle: string }> = {
  chrome: {
    group: 'border-chrome-line bg-chrome-2',
    active: 'bg-chrome-accent text-chrome',
    idle: 'text-chrome-muted hover:bg-chrome hover:text-chrome-ink',
  },
  surface: {
    group: 'border-line bg-surface-2',
    active: 'bg-brand text-brand-ink',
    idle: 'text-ink-muted hover:bg-surface hover:text-ink',
  },
};

export function LangSwitch({
  tone = 'chrome',
}: { readonly tone?: LangSwitchTone } = {}): ReactNode {
  const { locale, setLocale, t } = useI18n();
  const skin = TONE_CLASSES[tone];

  return (
    <div
      role="group"
      aria-label={t('nav.language')}
      /*
       * Ichki `p-0.5` — faol segment tashqi ramkaga YOPISHIB qolmasligi
       * uchun. Usiz to'ldirilgan to'rtburchak chegaraning ustiga chiqadi va
       * segment «buzilgan tugma» ko'rinishini oladi.
       *
       * ┌────────────────────────────────────────────────────────────────────┐
       * │ RANGLAR `chrome-*` DAN — CHUNKI BU KORPUS, SIRT EMAS               │
       * │                                                                    │
       * │ Ilgari bu yerda `border-line bg-surface-2` turardi va u yuqori      │
       * │ panel OQ bo'lganda to'g'ri edi. Panel chuqur jadega o'tgach o'sha   │
       * │ tokenlar YO'QOLDI: `bg-surface-2` yorug' mavzuda deyarli oq, ya'ni  │
       * │ jade fonda oq quti bo'lib turardi, `border-line` esa ko'rinmasdi.   │
       * │                                                                    │
       * │ `chrome-*` tokenlari mavzuga BOG'LIQ EMAS (`styles.css`), shuning   │
       * │ uchun bu yerda `dark:` variantlari yo'q va bo'lmaydi ham: korpus    │
       * │ ikkala mavzuda ham bir xil yashil.                                  │
       * │                                                                    │
       * │ ⚠️ Bu xulosa KORPUS uchun to'g'ri, lekin faqat u uchun. Vidjet      │
       * │ yorug' sirtga ham chiqqach (`tone="surface"` — kirish ekrani),      │
       * │ tokenlar `TONE_CLASSES` ga ko'chdi: o'sha yerda `surface-*` va      │
       * │ `ink-*` ishlatiladi va ular mavzu bilan BIRGA almashadi.            │
       * └────────────────────────────────────────────────────────────────────┘
       */
      /*
       * ╔════════════════════════════════════════════════════════════════════╗
       * ║ BALANDLIK ENDI E'LON QILINADI (`h-9`) — ILGARI U TASODIF EDI       ║
       * ║                                                                    ║
       * ║ Bu yerda balandlik umuman yozilmagan edi va u ichki qiymatlardan   ║
       * ║ YIG'ILARDI: `p-0.5` (2) + `py-1` (4) + `text-xs leading-none` (12) ║
       * ║ + `py-1` (4) + `p-0.5` (2) = 24 px. Yonidagi kurs chipi 32,        ║
       * ║ qo'ng'iroq esa 36 px edi — ya'ni til almashtirgich qatordagi eng   ║
       * ║ past element bo'lib, panelda «cho'kib» turardi.                     ║
       * ║                                                                    ║
       * ║ Balandlik endi SHU YERDA belgilanadi, ya'ni ichkaridagi `px`/`py`  ║
       * ║ o'zgarsa ham element qatordan chiqib ketmaydi.                      ║
       * ╚════════════════════════════════════════════════════════════════════╝
       */
      className={`inline-flex h-9 shrink-0 items-center gap-0.5 rounded-lg border p-1 ${skin.group}`}
    >
      {LOCALES.map((code) => {
        const active = code === locale;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLocale(code)}
            aria-pressed={active}
            title={FULL_LABELS[code]}
            /*
             * Faol segment — TO'LDIRILGAN rang, faqat qalin shrift emas:
             * qalinlik ikki harfda deyarli sezilmaydi.
             *
             * ╔══════════════════════════════════════════════════════════════╗
             * ║ TO'LDIRISH `chrome-accent`, `chrome-2` EMAS                  ║
             * ║                                                              ║
             * ║ Guruhning O'ZI allaqachon `bg-chrome-2` da turibdi. Ya'ni    ║
             * ║ faol segmentga ham `bg-chrome-2` berilsa, u fonga QO'SHILIB  ║
             * ║ ketardi va joriy til umuman ko'rinmasdi — bu esa butun       ║
             * ║ vidjetning maqsadi (yuqoridagi izoh: «joriy tilni RANG       ║
             * ║ bilan ko'rsatadi, o'qish shart emas»).                        ║
             * ║                                                              ║
             * ║ Korpus grafitga o'tgach urg'u LIMONDAN LOGONING YASHILIGA    ║
             * ║ qaytdi (`styles.css`). Bu yerda u ikki marta to'g'ri keldi:  ║
             * ║ limon ikki harflik nishonda ham baqirardi, yashil esa        ║
             * ║ yon menyudagi faol band bilan bir xil signal beradi — ko'z   ║
             * ║ «faol» ni butun ilovada BITTA rangda o'rganadi.              ║
             * ║                                                              ║
             * ║ Matn grafit (`text-chrome`): yashil ustida kontrasti 6.03,   ║
             * ║ oq esa 2.95 — ya'ni oq matn bu yerda o'qilmasdi.             ║
             * ╚══════════════════════════════════════════════════════════════╝
             *
             * Aniq ranglar endi `TONE_CLASSES` da (yuqoridagi jadval), chunki
             * ular yuzaga qarab ikki xil. Yuqoridagi «to'ldirilgan rang,
             * qalin shrift emas» qarori esa IKKALA tusda ham bir xil.
             *
             * `motion-reduce:transition-none` — rang o'tishi harakat emas,
             * lekin sozlamani hurmat qilish arzon va izchil.
             */
            /*
             * `text-xs px-1.5` EDI — ya'ni bosish nishoni ~26×20 px. Bu
             * sichqoncha uchun ham chegarada, planshetdagi barmoq uchun esa
             * kam: yonma-yon turgan uchta shunday nishonda «RU» o'rniga
             * «UZ» bosilishi oddiy hol edi. Endi nishon to'liq balandlikni
             * (`h-full`) oladi va eni `px-2.5` bilan kengaydi.
             */
            className={`flex h-full items-center rounded-md px-2 text-sm leading-none font-semibold tracking-wide transition-colors motion-reduce:transition-none sm:px-2.5 ${
              active ? skin.active : skin.idle
            }`}
          >
            {SHORT_LABELS[code]}
          </button>
        );
      })}
    </div>
  );
}
